import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
  Typography,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Dialog,
} from "@material-ui/core";

const ErrorModal = ({ openError, setOpenError, errorMsg }) => {
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={openError}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{"Error"}</Typography>
          <CloseIcon
            onClick={() => setOpenError(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        <div
          style={{ display: "flex", textWrap: "wrap", wordBreak: "break-word" }}
        >
          {errorMsg ? errorMsg : "Error"}
        </div>
      </MuiDialogContent>
    </Dialog>
  );
};

export default ErrorModal;
